/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { doctorPrincipiosActivosControllerCrearInteraccionPrincipioActivo } from '../fn/doctor-principios-activos/doctor-principios-activos-controller-crear-interaccion-principio-activo';
import { DoctorPrincipiosActivosControllerCrearInteraccionPrincipioActivo$Params } from '../fn/doctor-principios-activos/doctor-principios-activos-controller-crear-interaccion-principio-activo';
import { doctorPrincipiosActivosControllerEliminarInteraccionPrincipioActivo } from '../fn/doctor-principios-activos/doctor-principios-activos-controller-eliminar-interaccion-principio-activo';
import { DoctorPrincipiosActivosControllerEliminarInteraccionPrincipioActivo$Params } from '../fn/doctor-principios-activos/doctor-principios-activos-controller-eliminar-interaccion-principio-activo';
import { doctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos } from '../fn/doctor-principios-activos/doctor-principios-activos-controller-get-interacciones-principios-activos';
import { DoctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos$Params } from '../fn/doctor-principios-activos/doctor-principios-activos-controller-get-interacciones-principios-activos';
import { doctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid } from '../fn/doctor-principios-activos/doctor-principios-activos-controller-get-interaccion-principio-activo-by-uuid';
import { DoctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid$Params } from '../fn/doctor-principios-activos/doctor-principios-activos-controller-get-interaccion-principio-activo-by-uuid';
import { doctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo } from '../fn/doctor-principios-activos/doctor-principios-activos-controller-modificar-grado-interaccion-principio-activo';
import { DoctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo$Params } from '../fn/doctor-principios-activos/doctor-principios-activos-controller-modificar-grado-interaccion-principio-activo';
import { InteraccionesPrincipiosActivosDto } from '../models/interacciones-principios-activos-dto';
import { ModificarGradoInteraccionPrincipioActivoDto } from '../models/modificar-grado-interaccion-principio-activo-dto';

@Injectable({ providedIn: 'root' })
export class DoctorPrincipiosActivosService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `doctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos()` */
  static readonly DoctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivosPath = '/api/principios-activos/interacciones';

  /**
   * Obtener todas las interacciones de principios activos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos$Response(params?: DoctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InteraccionesPrincipiosActivosDto>>> {
    return doctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener todas las interacciones de principios activos.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos(params?: DoctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos$Params, context?: HttpContext): Observable<Array<InteraccionesPrincipiosActivosDto>> {
    return this.doctorPrincipiosActivosControllerGetInteraccionesPrincipiosActivos$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<InteraccionesPrincipiosActivosDto>>): Array<InteraccionesPrincipiosActivosDto> => r.body)
    );
  }

  /** Path part for operation `doctorPrincipiosActivosControllerCrearInteraccionPrincipioActivo()` */
  static readonly DoctorPrincipiosActivosControllerCrearInteraccionPrincipioActivoPath = '/api/principios-activos/interacciones';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorPrincipiosActivosControllerCrearInteraccionPrincipioActivo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorPrincipiosActivosControllerCrearInteraccionPrincipioActivo$Response(params: DoctorPrincipiosActivosControllerCrearInteraccionPrincipioActivo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return doctorPrincipiosActivosControllerCrearInteraccionPrincipioActivo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorPrincipiosActivosControllerCrearInteraccionPrincipioActivo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorPrincipiosActivosControllerCrearInteraccionPrincipioActivo(params: DoctorPrincipiosActivosControllerCrearInteraccionPrincipioActivo$Params, context?: HttpContext): Observable<void> {
    return this.doctorPrincipiosActivosControllerCrearInteraccionPrincipioActivo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `doctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid()` */
  static readonly DoctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuidPath = '/api/principios-activos/interacciones/{interaccionUuid}';

  /**
   * Obtener una interacción de principios activos por UUID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid$Response(params: DoctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid$Params, context?: HttpContext): Observable<StrictHttpResponse<InteraccionesPrincipiosActivosDto>> {
    return doctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener una interacción de principios activos por UUID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid(params: DoctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid$Params, context?: HttpContext): Observable<InteraccionesPrincipiosActivosDto> {
    return this.doctorPrincipiosActivosControllerGetInteraccionPrincipioActivoByUuid$Response(params, context).pipe(
      map((r: StrictHttpResponse<InteraccionesPrincipiosActivosDto>): InteraccionesPrincipiosActivosDto => r.body)
    );
  }

  /** Path part for operation `doctorPrincipiosActivosControllerEliminarInteraccionPrincipioActivo()` */
  static readonly DoctorPrincipiosActivosControllerEliminarInteraccionPrincipioActivoPath = '/api/principios-activos/interacciones/{interaccionUuid}';

  /**
   * Eliminar una interacción de principios activos por UUID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorPrincipiosActivosControllerEliminarInteraccionPrincipioActivo()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorPrincipiosActivosControllerEliminarInteraccionPrincipioActivo$Response(params: DoctorPrincipiosActivosControllerEliminarInteraccionPrincipioActivo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return doctorPrincipiosActivosControllerEliminarInteraccionPrincipioActivo(this.http, this.rootUrl, params, context);
  }

  /**
   * Eliminar una interacción de principios activos por UUID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorPrincipiosActivosControllerEliminarInteraccionPrincipioActivo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorPrincipiosActivosControllerEliminarInteraccionPrincipioActivo(params: DoctorPrincipiosActivosControllerEliminarInteraccionPrincipioActivo$Params, context?: HttpContext): Observable<void> {
    return this.doctorPrincipiosActivosControllerEliminarInteraccionPrincipioActivo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `doctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo()` */
  static readonly DoctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivoPath = '/api/principios-activos/interacciones/{interaccionUuid}';

  /**
   * Modificar el grado de una interacción de principios activos por UUID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo$Response(params: DoctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo$Params, context?: HttpContext): Observable<StrictHttpResponse<ModificarGradoInteraccionPrincipioActivoDto>> {
    return doctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo(this.http, this.rootUrl, params, context);
  }

  /**
   * Modificar el grado de una interacción de principios activos por UUID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo(params: DoctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo$Params, context?: HttpContext): Observable<ModificarGradoInteraccionPrincipioActivoDto> {
    return this.doctorPrincipiosActivosControllerModificarGradoInteraccionPrincipioActivo$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModificarGradoInteraccionPrincipioActivoDto>): ModificarGradoInteraccionPrincipioActivoDto => r.body)
    );
  }

}
